import ApiService from "@/services/Api"

type MigrationRequestData = {
	name: string
	phone: string
	objective: string
}

class WABAMigrationService {
	async submitMigrationRequest (data: MigrationRequestData): Promise<void> {
		await ApiService.post("/waba/migration/request", data)
	}
}

export default new WABAMigrationService()
